import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export interface OsReportSummary {
  total: number;
  completed: number;
  avgTicket: number;
  reworkRate: number;
}

export interface MechanicRow {
  mechanicId: string;
  mechanicName: string;
  total: number;
  completed: number;
  avgTicket: number;
}

export interface CategoryRow {
  category: string;
  count: number;
  revenue: number;
}

export interface TimelinePoint {
  date: string;
  opened: number;
  completed: number;
}

interface OsReportData {
  summary: OsReportSummary;
  byMechanic: MechanicRow[];
  byCategory: CategoryRow[];
  timeline: TimelinePoint[];
}

interface UseOsReportsOptions {
  from: string;
  to: string;
  mechanicId?: string;
  status?: string;
}

export function useOsReports(opts: UseOsReportsOptions) {
  return useQuery<OsReportData>({
    queryKey: ['os-reports', opts.from, opts.to, opts.mechanicId, opts.status],
    queryFn: async () => {
      const params = new URLSearchParams({ from: opts.from, to: opts.to });
      if (opts.mechanicId) params.set('mechanicId', opts.mechanicId);
      if (opts.status) params.set('status', opts.status);
      const res = await api.get(`/workshops/my/service-orders/reports?${params}`);
      return res.data;
    },
  });
}
